module.exports = __webpack_public_path__ + "img/contenedor31.27beb730.png";